import { useEffect, useState } from 'react';
import { subscribeMarketThumbs } from '@formosa/shared/socket/marketThumbSocket';
import { normalizeSymbolCode, normalizeSymbolCodes } from '@formosa/shared/utils/marketThumb';

function mergeThumbEntry(prev, thumb) {
  if (!thumb?.code) {
    return prev;
  }
  const key = normalizeSymbolCode(thumb.code);
  return {
    ...prev,
    [key]: { ...prev[key], ...thumb, code: key },
  };
}

/**
 * 訂閱行情 thumb（Socket.IO thumbSnapshot + thumbUpdate）。
 * 初始資料由 subscribeThumb 回傳快照，不再重複打 REST market/thumb。
 */
export default function useMarketThumbSocket(symbolCodes) {
  const [thumbs, setThumbs] = useState({});

  // 序列化成字串，避免呼叫端每次 render 傳新陣列導致 effect 重跑
  const codesKey = normalizeSymbolCodes(symbolCodes).join(',');

  useEffect(() => {
    if (!codesKey) {
      setThumbs({});
      return undefined;
    }

    const codes = codesKey.split(',');
    let cancelled = false;

    const unsubscribe = subscribeMarketThumbs(codes, {
      onSnapshot: (list) => {
        if (cancelled || !Array.isArray(list)) {
          return;
        }
        setThumbs((prev) => {
          let next = prev;
          list.forEach((thumb) => {
            next = mergeThumbEntry(next, thumb);
          });
          return next;
        });
      },
      onUpdate: (thumb) => {
        if (cancelled) {
          return;
        }
        setThumbs((prev) => mergeThumbEntry(prev, thumb));
      },
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [codesKey]);

  return thumbs;
}
